var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g-button',{staticClass:"mx-2",attrs:{"label":"Export","icon":"get_app","loading":_vm.loading},on:{"onclick":_vm.exportData}})
}
var staticRenderFns = []

export { render, staticRenderFns }